import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "@/i18n";
import { Eyebrow, Reveal } from "./Reveal";

export const FAQ = () => {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F3EFE6] py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-14">
          <Eyebrow>{t.faq.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
            {t.faq.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="border-t border-[#0A1F18]/15">
            {t.faq.items.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={item.q} className="border-b border-[#0A1F18]/15" data-testid={`faq-item-${i}`}>
                  <button
                    data-testid={`faq-item-${i}-trigger`}
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span
                      className={`font-display text-lg font-medium tracking-tight transition-colors duration-300 sm:text-xl ${
                        isOpen ? "text-[#B36C45]" : "text-[#0A1F18] group-hover:text-[#B36C45]"
                      }`}
                    >
                      {item.q}
                    </span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-[#B36C45] transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          data-testid={`faq-item-${i}-answer`}
                          className="max-w-2xl pb-7 text-base leading-relaxed text-[#5C6B64]"
                        >
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
